import React from "react";

// PT Hiring Solutions emblem displayed inside a clean white rounded badge
const LogoMark = ({ size = 44, className = "" }) => (
  <div
    className={`rounded-md bg-white flex items-center justify-center overflow-hidden shrink-0 shadow-sm ${className}`}
    style={{ width: size, height: size, padding: size * 0.08 }}
  >
    <img
      src="/assets/logo-mark.png"
      alt="PT Hiring Solutions logo"
      className="w-full h-full object-contain"
    />
  </div>
);

export default LogoMark;
